import { formatNumber, parseNumber } from "./number_helper"
import { Chart } from "chart.js"
import { buildTooltip } from "./dashboard_tooltip"

const purchaseColor = "#00bae6"
const swissgridBalanceColor = "#418c9c"
const saleColor = "#cfc7c0"

const technologyGraphConfig = (report) => {
  const purchase = Object.values(report.by_status)
    .map((status) => parseNumber(status.purchase))
    .reduce((sum, value) => sum + value, 0)

  const swissgridBalance = parseNumber(report.swissgrid_balance)
  const sale = Object.values(report.by_status)
    .map((status) => parseNumber(status.sale))
    .reduce((sum, value) => sum + value, 0)

  const data = [purchase, swissgridBalance, 0, sale]
  const barColors = [
    purchaseColor,
    swissgridBalanceColor,
    "transparent",
    saleColor,
  ]

  const difference = purchase - sale

  return {
    data: {
      labels: ["E", "K", "", "V"],
      datasets: [
        {
          data,
          backgroundColor: barColors,
        },
      ],
    },
    options: {
      locale: "de-CH",
      barThickness: (window.innerWidth * 2) / 300,
      scales: {
        x: {
          grid: { display: false, color: Chart.defaults.color },
          border: { color: Chart.defaults.color },
        },
        y: {
          grid: { drawOnChartArea: false, color: Chart.defaults.color },
          border: { color: Chart.defaults.color },
          beginAtZero: true,
        },
      },
      animations: { y: { easing: "easeOutBounce" } },
      plugins: {
        legend: { display: false },
        title: {
          display: true,
          text: report.title,
          padding: { bottom: 24 },
        },
        subtitle: {
          display: true,
          text: `${formatNumber(difference, { signDisplay: "exceptZero" })} MWh`,
          color: purchase >= sale ? "#6a8f04" : "#e95207",
          position: "bottom",
        },
        datalabels: { display: false },
        tooltip: {
          enabled: false,
          external: (context) => {
            const { tooltip } = context

            let relevantKey
            let total

            const title = tooltip.title?.[0] || ""

            // Head (title)

            let head
            if (title === "E") {
              relevantKey = "purchase"
              head = "Vertragslage Einkauf"
            } else if (title === "K") {
              relevantKey = "swissgrid_balance"
              head = "Kontostand Pronovo"
            } else if (title === "V") {
              relevantKey = "sale"
              head = "Vertragslage Verkauf"
            }

            // Body

            const body = []
            if (title === "E" || title === "V") {
              total = Object.values(report.by_status)
                .map((status) => parseNumber(status[relevantKey]))
                .reduce((sum, value) => sum + value, 0)

              Object.entries(report.by_status).forEach(([status, values]) => {
                const value = parseNumber(values[relevantKey])
                const relativeValue = value / total

                body.push([
                  status,
                  `${formatNumber(value, { maximumFractionDigits: 0 })} MWh`,
                  `${formatNumber(relativeValue * 100, { maximumFractionDigits: 2 })}%`,
                ])
              })
            } else {
              total = parseNumber(report.swissgrid_balance)
            }

            // Foot (sum row)

            const foot = [
              "Total:",
              `${formatNumber(total, { maximumFractionDigits: 0 })} MWh`,
              "100%",
            ]

            buildTooltip(context, { head, body, foot })
          },
        },
      },
    },
  }
}

export { technologyGraphConfig }
